import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const RedirectIfAuth = ({ children }) => {
  const isAuthenticated = Cookies.get('adminToken');
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

export default RedirectIfAuth;
